export class UserSession {
    userId: number;
    userFullName: string;
    userFirstName:string;
    userLastName:string;
    email:string;
    mobileNo:number;
    whatsAppNumber:number;
    roleId: number;
    identificationNo:string;
    authToken: string;
    roleName: string;
    mustChangePassword : boolean;
  }
